import styled from 'styled-components'

export default styled.p`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 10px;
  width: fit-content;
  margin: 0;
  padding: 14px 20px;
  border-radius: 10px;
  background-color: ${ ({ theme }) => theme.colors.lightBlue };
  color: ${ ({ theme }) => theme.colors.blue };
  font-family: ${ ({ theme }) => theme.fontFamily };
  font-size: 14px;
  font-weight: 600;
  line-height: 22.6px;
  letter-spacing: 0;
  text-align: left;

  .mark {
    font-size: 26px;
    font-weight: 800;
    line-height: 20px;
    transform: translateY(5px);
  }
`
